module.exports = __webpack_public_path__ + "img/guozai_05.01f9ae29.jpg";